import {bindingMode, customElement, bindable, noView} from "aurelia-framework";

@noView()
@customElement('scriptinjector')
export class scriptinjector {

  @bindable url;
  @bindable isAsync;
  @bindable onload;
  @bindable({defaultBindingMode: bindingMode.oneWay}) scripttag;

  attached() {
    if (this.url) {
      this.scripttag = document.createElement('script');
      if (this.isAsync) {
        this.scripttag.async = true;
      }
      this.scripttag.setAttribute('src', this.url);

      if(this.id)
        this.scripttag.setAttribute('id', this.id);
      document.body.appendChild(this.scripttag);
    }
    if(this.onload){
      this.scripttag.setAttribute('onload',this.onload);
    }
  }

  detached() {
    if (this.scripttag) {
      this.scripttag.remove();
    }
  }
}
